// extracted by mini-css-extract-plugin
export default {"logo":"logo___CzlX9"};